<template>
    <div class="container pt-lg-4">
        <h1>Galeria {{ city }}</h1>
        <div class="card-columns">
            <gallery :images="images" :index="index" @close="index = null"></gallery>
            <div class="card" v-for="image, imageIndex in images" @click="index = imageIndex">
                <img :src="image" class="card-img-top">
            </div>

        </div>
    </div>
</template>

<script>
import VueGallery from 'vue-gallery';
import galleryImages from './../gallery';
import project from '../project';

export default {
  data() {
    return {
      city: project.project(this.$route.params.slug),
      images: galleryImages.getGalleryImages(this.$route.params.slug),
      index: null,
    };
  },
  components: {
    'gallery': VueGallery,
  },
};
</script>

<style lang="scss">
    .blueimp-gallery > .close {
        color: white !important;
    }
</style>
